import { render, staticRenderFns } from "./pcb_ban_size.vue?vue&type=template&id=3052cc10&scoped=true"
import script from "./pcb_ban_size.vue?vue&type=script&lang=js"
export * from "./pcb_ban_size.vue?vue&type=script&lang=js"
import style0 from "./pcb_ban_size.vue?vue&type=style&index=0&id=3052cc10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052cc10",
  null
  
)

export default component.exports